import React, { useState } from 'react';
import { Box, Avatar, Typography, keyframes, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAIWidget } from '../../../context/AIWidgetContext';

const pulseAnimation = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(242, 28, 99, 0.4); }
  70% { box-shadow: 0 0 0 15px rgba(242, 28, 99, 0); }
  100% { box-shadow: 0 0 0 0 rgba(242, 28, 99, 0); }
`;

const bounceAnimation = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
`;

const FloatingAgentBubble = () => {
  const { openAssistant, isAssistantOpen } = useAIWidget();
  const [showBanner, setShowBanner] = useState(true);

  // Si el widget ya está abierto, ocultamos la burbuja
  if (isAssistantOpen) return null; 

  return (
    <Box
      onClick={openAssistant}
      sx={{
        position: 'fixed',
        bottom: { xs: 16, md: 32 },
        right: { xs: 16, md: 32 },
        zIndex: 200000, // Igual que el carrito para estar por encima de todo
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        cursor: 'pointer',
        animation: `${bounceAnimation} 4s infinite ease-in-out`,
        '&:hover .tooltip': {
          opacity: 1,
          transform: 'translateX(0)',
        },
        '&:hover .avatar': {
          transform: 'scale(1.05)',
        }
      }}
    >
      {/* Tooltip de Mensaje (Invitación a interactuar) */}
      {showBanner && (
        <Box
          className="tooltip"
          sx={{
            backgroundColor: '#ffffff',
            color: '#111111',
            padding: '12px 16px',
            borderRadius: '16px 16px 4px 16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            border: '1px solid rgba(0,0,0,0.05)',
            opacity: { xs: 1, md: 0 },
            transform: { xs: 'translateX(0)', md: 'translateX(10px)' },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            whiteSpace: 'nowrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            position: 'relative', // Para posicionar la X
          }}
        >
          {/* Botón X para cerrar solo el banner */}
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation(); // Evita que se abra el asistente
              setShowBanner(false);
            }}
            sx={{
              position: 'absolute',
              top: -8,
              left: -8,
              bgcolor: '#ffffff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: '1px solid #eee',
              width: 22,
              height: 22,
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
          >
            <CloseIcon sx={{ fontSize: '14px', color: '#666' }} />
          </IconButton>

          <Typography 
            variant="caption" 
            sx={{ 
              color: '#F21C63', 
              fontWeight: 800, 
              fontSize: '0.65rem', 
              textTransform: 'uppercase', 
              letterSpacing: '0.5px', 
              mb: 0.5 
            }}
          >
            Consultor AI
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 600, 
              fontSize: '0.9rem',
              color: '#1e293b'
            }}
          >
            ¿Diagnosticamos tu negocio?
          </Typography>
        </Box>
      )}

      {/* Burbuja Principal / Avatar */}
      <Box
        className="avatar"
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          backgroundColor: '#F21C63', // Color de marca principal de Hitpoly
          padding: '3px',
          boxShadow: '0 8px 24px rgba(242, 28, 99, 0.35)',
          animation: `${pulseAnimation} 2.5s infinite`,
          transition: 'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}
      >
        <Avatar 
          src="https://i.pravatar.cc/150?img=5" // Combina con la primera persona del array de Agentes
          sx={{ 
            width: '100%', 
            height: '100%', 
            border: '2px solid white' 
          }} 
        />
        {/* Indicador verde de "Online" */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 1,
            right: 1,
            width: 14,
            height: 14,
            backgroundColor: '#22c55e',
            borderRadius: '50%',
            border: '2px solid white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
        />
      </Box>
    </Box>
  );
};

export default FloatingAgentBubble;
